module.exports = __webpack_public_path__ + "static/media/Nokora-Bold.bcb93d32.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Nokora-Bold.ttf
// module id = 550
// module chunks = 0